import { render, staticRenderFns } from "./archive-property.vue?vue&type=template&id=14a4c9b2"
import script from "./archive-property.vue?vue&type=script&lang=js"
export * from "./archive-property.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports